import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { InputNumber, Select, Input, DatePicker, Switch, Button } from 'antd';
//import queryString from 'query-string'
// import { withRouter } from 'react-router'

const definicaoTipo = {
  bool: { operadores: ['=', '!='], valorPadrao: false },
  number: { operadores: ['=', '>=', '<=', '!='], valorPadrao: 0 },
  string: { operadores: ['=', '>=', '<=', '!='], valorPadrao: '' },
  date: { operadores: ['=', '>=', '<=', '!='], valorPadrao: null },
  rangeDate: { operadores: ['between'], valorPadrao: null },
};

export class FiltroDinamico extends Component {
  static propTypes = {
    tipoSaida: PropTypes.oneOf(['loopback', 'js']).isRequired,
    funcAplicarFilter: PropTypes.func.isRequired,
    filterBase: PropTypes.shape({
      filter: PropTypes.shape({
        where: PropTypes.object,
        limit: PropTypes.number,
        skip: PropTypes.number,
      }),
    }).isRequired,
    filterInicial: PropTypes.shape({
      filter: PropTypes.shape({
        where: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            nomeCampo: PropTypes.string,
            descricaoCampo: PropTypes.string,
            tipo: PropTypes.string,
          }),
        ),
        limit: PropTypes.number,
        skip: PropTypes.number,
      }),
    }).isRequired,
    data: PropTypes.shape({
      titulo: PropTypes.string,
      campos: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          nomeCampo: PropTypes.string,
          descricaoCampo: PropTypes.string,
          tipo: PropTypes.string,
        }),
      ),
    }).isRequired,
  };
  getLocation() {
    // this is the best way to get the current search value?
    let location;
    // this.props.router.listen(routerState => {
    //   location = routerState
    // })()  // immediately unlisten
    return location;
  }
  constructor(props) {
    super(props);
    this.state = {
      listaFiltros: [
        {
          campo: '',
          operador: '=',
          tipoCampo: 'string',
          valor: '',
        },
      ],
    };
  }

  componentDidMount = () => {
    //  const { search } = this.getLocation();
    //  console.log(search);
    // console.log (this.context);
    const {
      filterInicial: {
        filter: { where },
      },
    } = this.props;

    const { listaFiltros } = this.state;
    if (where.length > 0) {
      this.setState({ listaFiltros: [...where, ...listaFiltros] });
    }
  };

  inicializarFiltro = () => ({
    campo: '',
    operador: '=',
    tipoCampo: 'string',
    valor: '',
  });

  gerarCampoValor = (filtro, index) => {
    const { tipoCampo } = filtro;
    const { RangePicker } = DatePicker;
    const dateFormat = 'DD/MM/YYYY';

    switch (tipoCampo) {
      case 'number':
        return (
          <InputNumber
            style={{ flex: 2, margin: 10 }}
            value={filtro.valor}
            onChange={e => this.preencherCampoValor('valor', e, index)}
          />
        );

      case 'bool':
        return (
          <span style={{ flex: 1, margin: 10, padding: 5 }}>
            <Switch
              size="default"
              checked={filtro.valor}
              onChange={e => this.preencherCampoValor('valor', e, index)}
            />
          </span>
        );

      case 'date':
        return (
          <DatePicker
            style={{ flex: 2, margin: 10 }}
            value={filtro.valor}
            format={dateFormat}
            onChange={(date, dateString) =>
              this.preencherCampoData('valor', date, dateString, index)
            }
          />
        );
      case 'rangeDate':
        return (
          <RangePicker
            style={{ flex: 2, margin: 10 }}
            value={filtro.valor}
            format={dateFormat}
            onChange={(date, dateString) =>
              this.preencherCampoData('valor', date, dateString, index)
            }
          />
        );
      default:
        return (
          <Input
            style={{ flex: 2, margin: 10 }}
            value={filtro.valor}
            onChange={e => this.preencherCampo('valor', e, index)}
          />
        );
    }
  };

  preencherCampoData = (nome, date, _dateString, index) => {
    if (Array.isArray(date)) {
      const dateBetween = date;
      dateBetween[0] = date[0].startOf('days');
      dateBetween[1] = date[1].endOf('days');
      this.preencherCampoValor(nome, dateBetween, index);
    } else {
      const newDate = date.startOf('days');
      // this.setState({ [nome]: newDate });
      this.preencherCampoValor(nome, newDate, index);
    }
  };

  obterTipoCampo = nomeCampo => {
    const {
      data: { campos },
    } = this.props;
    return campos.find(item => item.nomeCampo === nomeCampo);
  };

  tratarFiltro = () => {
    const { listaFiltros } = this.state;
    //  console.log(filtro);
    const where = {};

    listaFiltros.forEach(filtro => {
      const { campo, operador, valor } = filtro;

      if (campo) {
        switch (operador) {
          case '>=':
            where[campo] = { gte: valor };

            break;
          case '<=':
            where[campo] = { lte: valor };

            break;
          case '!=':
            where[campo] = { neq: valor };

            break;
          case 'between':
            where[campo] = { between: valor };

            break;

          default:
            where[campo] = valor;

            break;
        }
      }
    });
    return where;
  };

  realizarBusca = async () => {
    const { tipoSaida, funcAplicarFilter, filterBase } = this.props;

    const where = this.tratarFiltro();
    const Tmpfilter = { filter: { ...filterBase.filter } };

    if (tipoSaida === 'loopback') {
      Tmpfilter.filter.where = { and: [filterBase.filter.where, where] };

      funcAplicarFilter(Tmpfilter);
    }
  };

  handleChangeOperador = (value, index) => {
    this.preencherCampoValor('operador', value, index);
  };

  handleChangeCampo = (value, index) => {
    const newState = this.obterTipoCampo(value);
    const definicao = definicaoTipo[newState.tipo];
    const newOperador = definicao.operadores[0];

    const { listaFiltros } = this.state;

    listaFiltros[index] = {
      campo: newState.nomeCampo,
      tipoCampo: newState.tipo,
      operadores: definicao.operadores,
      operador: newOperador,
      valor: definicao.valorPadrao,
    };
    this.setState({ listaFiltros });
  };

  preencherCampo = (nome, item, index) => {
    this.preencherCampoValor(nome, item.target.value, index);
  };

  preencherCampoValor = (nome, value, index) => {
    const { listaFiltros } = this.state;
    listaFiltros[index] = {
      ...listaFiltros[index],
      [nome]: value,
    };
    this.setState({ listaFiltros });
  };

  adicionarFiltro = () => {
    const { listaFiltros } = this.state;

    listaFiltros.push(this.inicializarFiltro());
    this.setState({ listaFiltros });
  };

  removerFiltro = (index, qtde = 1) => {
    const { listaFiltros } = this.state;

    listaFiltros.splice(index, qtde);

    if (listaFiltros.length === 0) {
      listaFiltros.push(this.inicializarFiltro());
    }
    this.setState({ listaFiltros });
  };

  montarItemFiltro = (filtro, index) => {
    const { data } = this.props;
    // const { campo, operador, valor } = filtro;
    const { Option } = Select;
    const { listaFiltros } = this.state;
    const { operadores } = definicaoTipo[filtro.tipoCampo];

    // console.log(this.state);
    const campos = data.campos.filter(campo => {
      const existente = listaFiltros.some(
        (item, ind) => campo.nomeCampo === item.campo && ind !== index,
      );

      return !existente;
    });
    return (
      <div style={{ display: 'flex' }} key={index}>
        <Button
          style={{ flex: 2, margin: 10 }}
          type="danger"
          onClick={() => this.removerFiltro(index)}
        >
          Remover Filtro
        </Button>
        <Select
          style={{ flex: 2, margin: 10 }}
          showSearch
          placeholder="Selecione o campo"
          optionFilterProp="children"
          value={filtro.campo}
          onChange={value => this.handleChangeCampo(value, index)}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {campos.map(item => (
            <Option key={item.id} value={item.nomeCampo}>
              {item.descricaoCampo}
            </Option>
          ))}
        </Select>

        <Select
          style={{ flex: 1, margin: 10 }}
          value={filtro.operador}
          showSearch
          placeholder="Selecione o Operador"
          optionFilterProp="children"
          onChange={value => this.handleChangeOperador(value, index)}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {operadores.map(item => (
            <Option key={item} value={item}>
              {item}
            </Option>
          ))}
        </Select>

        {this.gerarCampoValor(filtro, index)}
        <Button style={{ flex: 2, margin: 10 }} type="primary" onClick={this.adicionarFiltro}>
          Adicionar Filtro
        </Button>
      </div>
    );
  };

  render() {
    const {
      data: { titulo },
    } = this.props;
    const { listaFiltros } = this.state;

    return (
      <div style={{ margin: 10 }}>
        <strong>{titulo}</strong>

        {listaFiltros.map((item, index) => this.montarItemFiltro(item, index))}

        <Button
          style={{ margin: 10 }}
          type="danger"
          onClick={() => {
            this.removerFiltro(0, listaFiltros.length);
          }}
        >
          {' '}
          Remover Todos
        </Button>
        <Button icon="search" type="primary" onClick={this.realizarBusca}>
          Buscar
        </Button>

        {/* <button type="button" >
          Buscar
        </button> */}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    componentes: state.componentes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FiltroDinamico);



// WEBPACK FOOTER //
// ./src/features/componentes/FiltroDinamico.js